import { useQuery } from '@tanstack/react-query';
import { getLessonQuiz } from '../queries/quiz';

function useFetchLessonQuiz(lessonId: string, showQuiz: boolean) {
  if (!showQuiz) {
    return {
      data: null,
      isError: false,
      isLoading: false,
      error: null,
      isSuccess: false,
    };
  }

  const { data, isError, error, isSuccess, isPending } = useQuery({
    queryKey: ['fetch-lesson-quiz', lessonId],
    queryFn: () => getLessonQuiz(lessonId),
    retry: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isError,
    isLoading: isPending,
    error,
    isSuccess,
  };
}

export { useFetchLessonQuiz };
